<template>
  <v-container
    id="customer-engagement-wrapper"
    class="pa-0 elevation-1 customer-engagement-service"
  >
    <v-card class="pa-5">
      <v-card-title
        class="pa-0"
        :class="$vuetify.breakpoint.smAndDown && 'title font-weight-regular'"
      >
        <v-row>
          <v-col
            cols="12"
            sm="10"
            class="pt-0"
          >
            <h4 class="customer-engagement d-inline">Customer Engagement </h4>
            <span class="subtitle-1 days">
             <template v-if="numberOfDays != 0"> (Last {{ numberOfDays }} days)</template>
             <template v-else>({{ moment(fromDate).format('MMM DD, YYYY') }} - {{ moment(toDate).format('MMM DD, YYYY') }})</template>
            </span>
          </v-col>
          <v-col
            cols="12"
            sm="2"
            class="text-right pa-0"
          >
            <v-menu
              v-model="pickerMenu"
              :close-on-content-click="false"
              :return-value.sync="dates"
              transition="scale-transition"
              offset-y
              min-width="220px"
            >
              <template v-slot:activator="{ on }">
                <template>
                  <v-btn
                    text
                    @click.stop="filterDrawer=!filterDrawer"
                    v-track="'show-hide-filter-drawer'"
                  >
                    <v-icon
                      color="grey"
                      class="pr-1 ml-n2"
                    >
                      mdi-filter-variant
                    </v-icon>
                    <!-- opt -->
                    <span
                      style="text-transform: capitalize;color:grey" 
                      class="body-2 font-weight-medium"
                    >
                      Filters
                    </span>
                  </v-btn>
                </template>
              </template>
          </v-menu>
          </v-col>
        </v-row>
      </v-card-title>
      <v-progress-linear
        v-if="loader"
        color="#03b6fc"
        class="mt-3"
        indeterminate
        height="4"
      />
      <v-container
        class="fix-activities-height px-6"
        :style="filterDrawer?'height:910px':'height:819px'"
      >
        <div
          v-if="!engagementData.length && !loader"
          style="height:80%"
          class="d-flex flex-column align-center"
        >
          <v-img
            contain
            width="870px"
            src="../../../assets/images/01_PageNoLongerExists.png"
          />
            <h4 class="grey--text text-center">
              No Activity Found
            </h4>
        </div>
        <v-row
          v-else-if="currentAccount.enable_marketing && roles.includes('contacts')"
          class="grey-border pb-4"
        >
          <v-col
            cols="12"
            sm="6"
            lg="3"
            class=" col"
          >
            <div :class="$vuetify.breakpoint.xsOnly?'pl-1':'pl-7'">
                <h5
                  :class="$vuetify.breakpoint.xlAndUp?'body-1':'body-2'"
                  class=" font-weight-medium customer-engagement-font"
                >
                  <v-icon size = "24" color = "mpBlue"> mdi-email-arrow-right-outline </v-icon> Sends
                </h5>
                <div class="headline font-weight-600 ml-7 ">
                  <span class="secondary--font">
                  {{ engagement_tiles_data.recent_sends_count }}
                </span>
                </div>
            </div>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            lg="3"
            class=" col"
          >
            <div :class="$vuetify.breakpoint.xsOnly?'pl-1':'pl-7'">
                <h5
                  :class="$vuetify.breakpoint.xlAndUp?'body-1':'body-2'"
                  class=" font-weight-medium customer-engagement-font"
                >
                <v-icon size = "24" color = "mpBlue"> mdi-email-open-outline </v-icon> Opens
                </h5>
                <div
                  style="width:100%"
                  class="headline  font-weight-600 ml-7 "
                >
                <span class="secondary--font">
                  {{ engagement_tiles_data.recent_opens_count }}
                </span>
                  <v-card-subtitle class="pa-0">
                    {{ engagement_tiles_data.recent_opens_count_percent }}
                  </v-card-subtitle>
                </div>
            </div>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            lg="3"
            class=" col"
          >
            <div :class="$vuetify.breakpoint.xsOnly?'pl-1':'pl-7'">
                <h5
                  :class="$vuetify.breakpoint.xlAndUp?'body-1':'body-2'"
                  class=" font-weight-medium customer-engagement-font"
                >
                  <v-icon size = "24" color = "mpBlue"> mdi-cursor-default-click </v-icon> Clicks
                </h5>
                <div class="headline font-weight-600 ml-7 ">
                  <span class="secondary--font">
                  {{ engagement_tiles_data.recent_clicks_count }}
                </span>
                  <v-card-subtitle class="pa-0">
                    {{ engagement_tiles_data.recent_clicks_count_percent }}
                  </v-card-subtitle>
                </div>
            </div>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            lg="3"
            class=" col"
          >
            <div :class="$vuetify.breakpoint.xsOnly?'pl-1':'pl-7'">
              <h5
                :class="$vuetify.breakpoint.xlAndUp?'body-1':'body-2'"
                class=" font-weight-medium customer-engagement-font"
              >
                <v-icon size = "24" color = "mpBlue"> mdi-email-remove-outline </v-icon> Bounces
              </h5>
              <div class="headline font-weight-600 ml-7 bounce-count ">
                <span  class="secondary--font">
                  {{ engagement_tiles_data.recent_bounces_rate || '--' }}</span>
              </div>
            </div>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            lg="3"
            class=" col"
          >
            <div :class="$vuetify.breakpoint.xsOnly?'pl-1':'pl-7'">
                <h5
                  :class="$vuetify.breakpoint.xlAndUp?'body-1':'body-2'"
                  class="d-flex font-weight-medium customer-engagement-font"
                >
                  <v-icon class="custom-align-icon" size = "24" color = "mpPink">mdi-cart-arrow-down </v-icon>
                  <span class="pl-1">Orders Placed</span>
                </h5>
                <div class="headline font-weight-600 ml-7 ">
                  <span  class="secondary--font">
                    {{ engagement_tiles_data.recent_orders_count }}</span>
                </div>
            </div>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            lg="3"
            class=" col"
          >
            <div :class="$vuetify.breakpoint.xsOnly?'pl-1':'pl-7'">
                <h5
                  :class="$vuetify.breakpoint.xlAndUp?'body-1':'body-2'"
                  class="d-flex font-weight-medium customer-engagement-font"
                >
                <v-icon class="custom-align-icon" size = "24" color = "mpPink"> mdi-cart-plus </v-icon>
                <span class="pl-1">Products Purchased</span>
                </h5>
                <div class="headline table-width font-weight-600 ml-7">
                  <span class="secondary--font"> 
                    {{ engagement_tiles_data.recent_product_purchased_count }}</span>
                </div>
            </div>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            lg="3"
            class=" col"
          >
            <div :class="$vuetify.breakpoint.xsOnly?'pl-1':'pl-7'">
              <h5
                :class="$vuetify.breakpoint.xlAndUp?'body-1':'body-2'"
                class="d-flex font-weight-medium customer-engagement-font"
              >
              <v-icon class="custom-align-icon" size = "24" color = "mpPink"> mdi-shopping-outline </v-icon>
              <span class=" pl-1">Total Items Purchased</span>
              </h5>
              <div class="headline font-weight-600 ml-7 ">
                <span  class="secondary--font">
                  {{ engagement_tiles_data.recent_items_purchased_count }}
                </span>
              </div>
            </div>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            lg="3"
            class=" col"
          >
            <div :class="$vuetify.breakpoint.xsOnly?'pl-1':'pl-7'">
                <h5
                  :class="$vuetify.breakpoint.xlAndUp?'body-1':'body-2'"
                  class="d-flex font-weight-medium customer-engagement-font"
                >
                  <v-icon class="custom-align-icon" size = "24" color = "mpPink"> mdi-currency-usd</v-icon>
                  <span >Total Revenue</span>
                </h5>
                <div class="headline font-weight-600 ml-7 ">
                  <span  class="secondary--font">
                    {{$options.filters.numberStatFormat(engagement_tiles_data.recent_orders_revenue) }}
                </span>
                </div>
            </div>
          </v-col>
        </v-row>
        <v-row
          v-for="item in engagementData"
          :key="item.unique_key"
          class="grey-border pb-1" 
        > 
          <v-col
            cols="12"
          >
            <order
              v-if="item.event_name === 'Order'"
              class="pa-0 service-order-view"
              :item="item"
            />
            <ticket
              v-else-if="item.event_name === 'Ticket'"
              class="pa-0 body-2"
              :item="item"
            />
            <abandoned-cart
              v-else-if="item.event_name === 'abandoned_carts'"
              class="pa-0 service-abandoned-view"
              :item="item"
            />
            <div v-else class="service-other-view">
            <!-- other parts -->
              <v-row>
                <v-col
                  cols="12"
                  sm="8"
                  class="pa-0"
                >
                  <div class="subtitle-1">
                    <div class="d-flex">
                      <v-icon :color="engagementDelegates[item.event_name].iconColor">
                        {{ engagementDelegates[item.event_name].icon }}
                      </v-icon>
                      <div class="ml-5 font-weight-medium word-break text-ellipsis">{{ engagementDelegates[item.event_name].name }}{{ item.title }}</div>
                    </div>
                  </div>
                </v-col>
                <v-col class="text-right pa-0" cols="12" sm="4">
                  <p
                    v-if="item.event_name=='Web'"
                    class="body-2"
                  >{{ $options.filters.formatDateTZ(item.action_time, 'MMM DD, YYYY') }}</p>
                  <div v-else-if="item.event_name=='Journey' ">
                    <p v-if="item.description == 'Active'" class="body-2">
                      <v-btn
                        class="text-capitalize caption"
                        text
                        small
                        color="primary"
                        v-track="'end-journey-dialog'"
                        @click="endJourneyDialog('open',item.attributes.journey_id)"
                        :disabled="endDisabled"
                      >End</v-btn>
                      <span class="blue--text">|</span>
                      <v-btn
                        class="text-capitalize caption font-weight-bold"
                        text
                        small
                        color="primary"
                        v-track="'restart-journey-dialog'"
                        @click="restartJournyDialog('open',item.attributes.journey_id)"
                        :disabled="resetDisabled"
                      >Restart</v-btn>
                      <br />
                      {{  $options.filters.formatDateTZ(item.action_time) }}
                    </p>
                    <p v-else-if="item.description=='Paused'" class="body-2">
                      <v-btn class="text-capitalize caption" text small color="primary" disabled>End</v-btn>
                      <span class="blue--text">|</span>
                      <v-btn
                        class="text-capitalize caption font-weight-bold"
                        text
                        small
                        color="primary"
                        v-track="'restart-journey-dialog'"
                        @click="restartDialog('open',item.attributes.journey_id)"
                        :disabled="resetDisabled"
                      >Restart</v-btn>
                      <br />
                      {{  $options.filters.formatDateTZ(item.action_time) }}
                    </p>
                  </div>
                    <p
                      v-else
                      class="body-2"
                    >{{  $options.filters.formatDateTZ(item.action_time) }}</p>
                  </v-col>
              </v-row>
              <v-row v-if="item.event_name !== 'Order' && item.event_name !== 'Ticket'">
                <v-col
                  cols="12"
                  :sm="item.event_name == 'Web' ? 12 : 6"
                  class = "mt-4 py-0"
                >
                  <div class="subtitle-2 font-weight-regular grey--text text--darken-2">
                  <span v-if="item.event_name == 'Campaign'">
                    <v-chip
                      :color="constants.STATUS[item.description].color"
                      outlined
                      small
                      class="ml-6 mr-2"
                    >
                      {{ constants.STATUS[item.description].name }}
                    </v-chip>
                    <span v-if="item.resent">
                      <v-chip
                        color="#41CE65"
                        outlined
                        small>
                        Re-sent
                      </v-chip>
                      <br>
                      <span class="grey-color ml-6"> on {{$options.filters.formatDateTZ(item.resent_at)}} </span>
                    </span>
                  </span>
                    <div
                      v-else-if="item.event_name == 'Web'"
                      class="d-flex"
                    >
                      <div
                        class="d-flex flex-column justify-space-between"
                        style="height:inherit;position:relative"
                      >
                        <div class="vr">
                          &nbsp;
                        </div>
                        <v-icon
                          small
                          color="#03B6FC"
                          class="bg-hide"
                        >
                          mdi-checkbox-blank-circle-outline
                        </v-icon>

                        <div
                          style="min-width:70px;"
                          class="caption bg-hide text-center"
                        >
                          {{ item.attributes.time_spent > 60 ? ((item.attributes.time_spent/60).toFixed(0) + ' hours') :( item.attributes.time_spent + ' mins') }}
                        </div>
                        <v-icon
                          color="#03B6FC"
                          small
                          class="bg-hide"
                        >
                          mdi-checkbox-blank-circle-outline
                        </v-icon>
                      </div>
                      <div
                        class="d-flex flex-column"
                        style="width:100%;"
                      >
                        <div
                          v-for="description of item.description"
                          :key="description.id"
                        >
                          <div class="d-flex justify-space-between flex-wrap">
                            <span class="web-history">
                              {{ description.url }}
                            </span>
                            <span class="web-history-time">
                              {{ $options.filters.formatDateTZ(description.created_at, 'MMM DD, YYYY') }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <v-chip
                      v-else-if="item.event_name=='Journey'"
                      :color="constants.STATUS[item.description].color"
                      outlined
                      small
                      class="ml-6"
                    >
                      {{ constants.STATUS[item.description].name }}
                    </v-chip>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  v-if="item.event_name !== 'Web'"
                  class = "justify-end d-flex flex-wrap pa-0 pt-2"
                >
                  <div v-if="item.event_name === 'Campaign'">
                    <v-tooltip
                      top
                      :disabled="canResend(item)"
                      color="rgba(0, 0, 0, 0.9)"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="mt-2 font-weight-bold"
                          small
                          outlined
                          color="black"
                          v-track="'resend-campaign-btn'"
                          @click="openLink(getResendUrl(item))"
                          :style="!canResend(item)?'cursor:not-allowed;color: grey !important;':'cursor:pointer'"
                          :ripple="canResend(item)"
                          v-on="on"
                        >Re-send Campaign</v-btn>
                      </template>
                      <div v-if="dnm"> Campaign can't be re-sent to DNM contacts</div>
                      <div v-else-if="item.hard_bounced"> Campaign can't be re-sent to Hard bounced contacts</div>
                      <div v-else-if="item.transactional"> Campaign can't be re-sent in case of transactional campaigns</div>                        
                    </v-tooltip>
                  </div>
                  <v-btn
                    v-if="item.detailed_url"
                    outlined
                    color="black"
                    v-track="'open-detailed-url'"
                    small
                    class="mt-2 ml-4 font-weight-bold"
                    @click="openLink(`/accounts/${account.id}${item.detailed_url}`)"
                  >Details</v-btn>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <div
      v-show="filterDrawer"
      class="navigation-drawar"
    >
      <v-navigation-drawer
        v-model="filterDrawer"
        right
        absolute
        temporary
        hide-overlay
        clipped
        width="450"
        class="between-filter-navigation"
      >
        <div class="pa-7 pt-5">
          <h2
            class="d-flex justify-space-between align center mb-1"
            style="font-size: 1.25rem;"
          >
            Filters
            <v-btn
              icon
              @click.stop="onOpenFilter()"
              v-track="'open-filter-btn'"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </h2>
          <v-btn
            outlined
            class="mt-2 font-weight-bold"
            v-track="'reset-filter-btn'"
            @click.stop="resetFilters();numberOfDays = 7;"
          >
            RESET
          </v-btn>
          <div class = "subtitle-1 mt-4">Date Range</div>
          <v-select
            v-model="numberOfDays"
            :items="range"
            item-text="name"
            item-value="value"
            label="View data for"
            outlined
            class="mt-4 strike-not-through"
            item-color = "black"
            :menu-props="{ offsetY: true }"
            attach
          />
          <div v-if="!numberOfDays" class = "d-flex">
            <v-menu
              ref="fromMenu"
              v-model="fromMenu"
              :close-on-content-click="false"
              :return-value.sync="fromDate"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  outlined
                  v-model="fromDate"
                  label="From"
                  append-icon="event"
                  readonly
                  v-bind="attrs"
                  class="pr-5 strike-not-through"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker color = "#03b6fc"
                no-title v-model="fromDate" :min="minDate" :max="getFromMaxDate" :show-current="currentDate" :picker-date.sync="startPickerDate">
                  <v-spacer></v-spacer>
                <v-btn text color="primary" @click="fromMenu = false" 
                 v-track="'cancel-from-menu-btn'">Cancel</v-btn>
                <v-btn text color="primary"
                v-track="'ok-from-menu-btn'" 
                @click="$refs.fromMenu.save(fromDate);getCustomerEngagementData()">OK</v-btn>
              </v-date-picker>
            </v-menu>
            <v-menu
              ref="toMenu"
              v-model="toMenu"
              :close-on-content-click="false"
              :return-value.sync="toDate"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  outlined
                  v-model="toDate"
                  label="To"
                  append-icon="event"
                  readonly
                  class="pl-2 strike-not-through"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker color = "mpBlue" :show-current="currentDate" :picker-date.sync="endPickerDate"
                no-title v-model="toDate" :min="minToDate" :max="getToMaxDate">
                <v-spacer></v-spacer>
                <v-btn text color="primary" 
                  v-track="'cancel-to-menu-btn'"
                  @click="toMenu = false">Cancel</v-btn>
                <v-btn text color="primary" 
                  v-track="'ok-to-menu-btn'"
                  @click="$refs.toMenu.save(toDate);getCustomerEngagementData()">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </div>
          <v-divider class = "my-3"/>
          <div class = "subtitle-1 overflow-auto mt-4">Type of data</div>
          <v-treeview
            v-if="filters.length"
            v-model="selectedFilter"
            selection-type="leaf"
            selectable
            dense
            open-all
            return-object
            selected-color="mpBlue"
            :items="filters"
            @update="getCustomerEngagementData"
          >
            <template v-slot:label="{ item }">
                {{ item.name }} ({{ item.count }})
            </template>
          </v-treeview>
        </div>
      </v-navigation-drawer>
    </div>
    </v-card>
    <!-- End Journey Dialog -->
    <v-dialog
      v-model="endDialog"
      max-width="500"
    >
      <v-card class="pa-4">
        <v-card-title class="text-h6 font-weight-medium-custom">
          <span class="secondary--font text-capitalize">End Journey</span>
        </v-card-title>
        <v-card-text class="body-2 pb-0">
          <p>
            Are you sure you want to End Journey?
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="endDialog('close')"
            class="font-weight-bold"
            v-track="'cancel-end-journey'"
          >
            No
          </v-btn>
          <v-btn
            dark
            @click="endJourney()"
            v-track="'yes-end-journey'"
            class="font-weight-bold"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Restart Journey Dialog -->
    <v-dialog
      v-model="campaignSuccess"
      max-width="1020"
    >
      <v-row
        no-gutters
      >
        <v-col cols="6" />
        <v-col
          cols="6"
          class="plane_img"
          justify="center"              
          align="center"
        >
        </v-col>
        <v-col
          cols="12"
        >
          <v-card
            class="mx-auto"
            max-width="565"
          >
            <v-row>
              <v-col
                cols="12"
                class="pt-5"
                justify="center"                   
                align="center"
              >
                <v-img
                  src="../../../assets/images/Congratulations_Message.png"
                  height="204px"
                  width="240px"
                />
              </v-col>
              <v-col
                cols="12"
              >
                <span class="title campaign_success">
                  <h4 class="secondary--font text-center">Congratulations!</h4>
                </span>
              </v-col>
              <v-col
                class="text-center pt-0"
                cols="12"
              >
                <p class="grey--text text--darken-2 pa-3 pt-0">
                  Your campaign {{ savedCampaignName }} has been successfully re-sent to the contact.
                </p>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-dialog>
    <v-dialog
      v-model="restartDialog"
      max-width="500"
    >
      <v-card class="pa-4">
        <v-card-title class="text-h6 font-weight-medium-custom">
          <span class="secondary--font text-capitalize">Restart Journey</span>
        </v-card-title>
        <v-card-text class="body-2 pb-0">
          <p>
            Resetting a contact to the beginning of the journey will
            result in sending of the same journey campaigns as originally sent!
            <br><br>
            Are you sure?
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="restartDialog('close')"
            class="font-weight-bold"
            v-track="'cancel-restart-journey'"
          >
            No
          </v-btn>
          <v-btn
            dark
            @click="restartJourney()"
            class="font-weight-bold"
            v-track="'yes-restart-journey'"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { $marketingContacts, $orders, $serviceContacts } from "@core/services"
  import constants from '@core/config/constants'
  import Order from './Order.vue';
  import Ticket from './Ticket.vue';
  import AbandonedCart from './AbandonedCart.vue';
  import { mapGetters } from "vuex"
  import moment from "moment";

  export default {
    name: 'CustomerEngagement',
    components: { Order, Ticket, AbandonedCart },
    props: {
      contactInfo: {
        type: Object,
      },
      dnm: {
        type: Boolean
      },
    },
    data: vm => ({
      endDialog: false,
      restartDialog: false,
      engagementData: [],
      openTree:false,
      numberOfDays: 7,
      config:undefined,
      fromMenu:false,
      toMenu:false,
      fromDate: vm.$options.filters.formatDateTZ(new Date(),'YYYY-MM-DD'),
      toDate: vm.$options.filters.formatDateTZ(new Date(),'YYYY-MM-DD'),
      startPickerDate:null,
      endPickerDate:null,
      currentDate:null,
      filterDrawer:false,
      dates:[],
      moment: moment,
      selectedFilter: [
        { id: 3, name: 'Bounced', parent:'email_campaign', value : 'bounced' },
        { id: 4, name: 'Clicked',parent:'email_campaign', value : 'clicked' },
        { id: 5, name: 'Delivered', parent:'email_campaign', value : 'delivered' },
        { id: 6, name: 'Opened', parent:'email_campaign', value : 'opened' },
        { id: 7, name: 'Unsubscribed',parent:'email_campaign', value : 'unsubscribed' },
        { id: 9, name: 'Active', parent : 'journey', value : 'Active' },
        { id: 10, name: 'Cleansed', parent : 'journey', value : 'Cleansed' },
        { id: 11, name: 'Finished', parent : 'journey', value : 'Finished'  },
        { id: 12, name: 'Paused' , parent : 'journey', value : 'Paused' },
        { id: 13, name: 'Unsubscribed', parent : 'journey', value : 'Unsubscribed'  },
        { id: 15, name: 'Orders', parent : 'commerce',value : 'orders' },
        { id: 16, name: 'abandoned_carts', parent : 'commerce',value : 'abandoned_carts' },
        { id: 17, name: 'Tickets',parent : 'service', value : 'tickets' },
      ],
      range:[{name:'Last 7 days',value:7},
      {name:'Last 15 days',value:15},
      {name:'Last 30 days',value:30},
      {name:'Custom',value:0}],
      daysOfWeek : ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        engagement_tiles_data: {
        recent_sends_count: '--',
        recent_bounces_rate: '--',
        recent_opens_count: '--',
        recent_opens_count_percent: '--',
        recent_clicks_count:'--',
        recent_clicks_count_percent:'--',
      },
      filters: [],
      constants: constants,
      engagementDelegates: {
        Campaign: { name: 'Email Campaign - ', icon: 'mdi-email', iconColor: '#03B6FC' },
        Order: { 
          name: 'Order #', 
          icon: 'mdi-cart', 
          iconColor: '#F53BAD',
        },
        Journey: { name: 'Journey - ', icon: 'mdi-email', iconColor: '#03B6FC' },
        Web: { name: 'Web Tracking', icon: 'mdi-television-guide', iconColor: '#41CE65' },
        ticket: { name: 'Service Ticket - ', icon: 'mdi-ticket-confirmation', iconColor: '#41CE65' },
      },
      contactId: null,
      journey_id: null,
      endDisabled: false,
      resetDisabled: false,
      pickerMenu:false,
      loader:false,
      visibleRange:[],
      campaignSuccess: false,
      savedCampaignName: false,
      typeOfData: {
        service: { tickets: 0}
      },
    }),
    watch:{
      numberOfDays(){
        if(!this.numberOfDays){
        this.fromDate = this.$options.filters.formatDateTZ(new Date(),'YYYY-MM-DD')
        this.toDate = this.$options.filters.formatDateTZ(new Date(),'YYYY-MM-DD')
        }
        this.getCustomerEngagementData()
      },
      selectedFilter:{
        handler(){
        this.getCustomerEngagementData()
        },
        deep:true
      },
      toDate:{
        handler(old,newV){
          this.endPickerDate = moment(this.toDate).format('YYYY-MM')
        }
      }
    },
    computed:{
      ...mapGetters({
        account: 'auth/account',
        currentAccount: 'auth/account.current',
        roles: 'auth/roles'
      }),
      getFromMaxDate() {
       return this.$options.filters.formatDateTZ(new Date(),'YYYY-MM-DD')
      },
      getToMaxDate(){
        let limitDate = new Date(moment(this.fromDate).add(31,'days'))
        if(this.fromDate && limitDate.getTime() < new Date().getTime()) {
          return moment(limitDate).format('YYYY-MM-DD')
        } else {
          return this.$options.filters.formatDateTZ(new Date(),'YYYY-MM-DD')
        }
      },
      minDate(){
        return this.$dateViaTZ(this.$dateViaTZ().getFullYear()-1000,1,1).toISOString().slice(0,10);
      },
      minToDate(){
        return new Date(this.fromDate).toISOString().slice(0,10);
      },
      date(){
        return this.$dateViaTZ()
      },
    },
    mounted () {
      this.contactId = this.$route.params.contactId
      if (process.env.VUE_APP_PRODUCT == 'Marketing') {
        this.selectedFilter = [3,4,5,6,7,8,9,10,11,12,13,15,16,17]
      }
      this.getCustomerEngagementData()
      setTimeout(() => { this.campaignSuccess = false }, 4000)
      this.currentDate = this.$options.filters.formatDateTZ(new Date(), 'YYYY-MM-DD')
      this.startPickerDate = this.$options.filters.formatDateTZ(new Date(), 'YYYY-MM')
      this.endPickerDate = this.$options.filters.formatDateTZ(new Date(), 'YYYY-MM')
    },
    methods: {
       canResend (item){
        return item.event_name === 'Campaign' && !item.transactional 
                    && !item.hard_bounced && !this.dnm
      },
      getResendUrl(item) {
       if(this.$route.params.listId){
        return `/accounts/${this.account.id}/lists/${this.$route.params.listId}/contacts/${this.contactId}/resend-campaign/${item.attributes.campaign_id}`
       }
       else { 
         return `/accounts/${this.account.id}/contacts/${this.contactId}/resend-campaign/${item.attributes.campaign_id}`
       }
      },
      async getCustomerEngagementData () {
        // Change the toDate if difference between fromDate and toDate is more than 31 days
       let limitDate = new Date(moment(this.fromDate).add(31,'days'))
       if(limitDate.getTime() < new Date(this.toDate).getTime()){
         this.toDate = moment(limitDate).format('YYYY-MM-DD')
       }
       // Change the toDate if fromDate is greater
      if(new Date(this.toDate).getTime() < new Date(this.fromDate).getTime()) {
         if(limitDate.getTime() > new Date().getTime()){
          this.toDate = this.$options.filters.formatDateTZ(new Date(),'YYYY-MM-DD')
         } else {
         this.toDate = this.$options.filters.formatDateTZ(limitDate,'YYYY-MM-DD')
         }
       }
      await this.fetchFiltersData()
      this.loader = true
      if(this.numberOfDays){
        this.config = {
          params : {
              days_count:this.numberOfDays,
              'contact[email]': this.contactInfo.email,
            }
          }
        } else {
          this.config = {
            params: {
              start_date: this.fromDate,
              end_date: this.toDate,
              'contact[email]': this.contactInfo.email,
            }
          }
        }
        let filter = {
          email_campaign:[],
          journey:[],
          service: [],
          orders: [],
          abandoned_carts: []
        }
        this.selectedFilter.map((element)=>{
          if(element.parent){
            if (element.parent === 'commerce') {
              // Preparing payload if parent type is commerce
              if (element.value === 'orders')
                filter.orders = [element.value]
              if (element.value === 'abandoned_carts')
               filter.abandoned_carts = [element.value]
            } else {
              filter[element.parent].push(element.value)
            }
          }
        })
        if(!filter.email_campaign.length){
          delete filter.email_campaign
        }
        if(!filter.journey.length){
          delete filter.journey
        }
        if(!filter.orders.length){
          delete filter.orders
        }
        if(!filter.abandoned_carts.length){
          delete filter.abandoned_carts
        }
        if(!filter.service.length){
          delete filter.service
        }
        this.config.params.filters = filter
        let marketingData = []
        let ticketData = []
        let resultData = []
        let orderData = []
        if (
          this.currentAccount.enable_marketing
          && this.roles.includes('contacts')
        ) {
          marketingData = await this.fetchMarketingData()
        }else{
          orderData = await this.fetchOrdersData() 
        }
        if (this.currentAccount.enable_service && this.$can('read','contacts')) {
          ticketData = await this.fetchTicketData()
        }
        resultData = [...ticketData, ...marketingData, ...orderData]
        // Sort data as per action date
        resultData = resultData.sort((a, b) => {
          const dateA = this.$dateViaTZ(a.action_time, 'YYYY-MM-DD HH:mm');
          const dateB = this.$dateViaTZ(b.action_time, 'YYYY-MM-DD HH:mm');
          return dateB - dateA;
        })
        resultData.forEach((element, index) => {
          resultData[index].showDetail = false;
          resultData[index].orderDetail = {};
          resultData[index].loading = true;
          element.unique_key = element.title + element.event_name + index
          if (element.event_name === 'Web') {
            element.description = [{ id: index, url: element.description, created_at: element.action_time }]
            for (let i = index + 1; i < resultData.length; i++) {
              if (resultData[i].event_name !== 'Web' ||
                element.action_time !== resultData[i].action_time ||
                element.attributes.website_id !== resultData[i].attributes.website_id) {
                break
              }
              element.attributes.time_spent += resultData[i].attributes.time_spent
              element.description.push({ id: i, url: resultData[i].description, created_at: resultData[i].action_time })
              resultData.splice(i, 1)
              i -= 1;
            }
          }
          if (element.event_name === 'Order') {
            resultData[index].order_date = element.action_time
            resultData[index].source_name = element.source_name
            resultData[index].source_type = element.source
            resultData[index].original_order_id = element.title
            resultData[index].grand_total = element.grand_total
            resultData[index].order_status = element.attributes.status
          }
        })
        this.engagementData = resultData;
        this.loader = false;
      },
      async fetchMarketingData () {
        this.fetchTilesData('recent_bounces_rate')
        this.fetchTilesData('recent_clicks_count')
        this.fetchTilesData('recent_opens_count')
        this.fetchTilesData('recent_sends_count')
        this.fetchTilesData('recent_orders_count')
        this.fetchTilesData('recent_orders_revenue')
        this.fetchTilesData('recent_product_purchased_count')
        this.fetchTilesData('recent_items_purchased_count')

        return await $marketingContacts.getRecentActivities(
          this.contactInfo.id, this.config
        ).then(async response => {
          let marketingData = response.data.data   
          return marketingData
        }).catch(() => {
          return []
        })
      },
      async fetchOrdersData () {
        return await $marketingContacts.getRecentActivities(
          this.contactInfo.id, this.config
        ).then(async response => {
          let marketingData = response.data.data.filter( (data)=>{
            if(data.event_name == 'Order'){
              return data 
              }
        }) 
          return marketingData
        }).catch(() => {
          return []
        })
      },
      // Fetch and manage Tickets data
      async fetchTicketData () {
        if (this.config.params.filters.service) {
          const payload = {
            email: this.contactInfo.email,
          }
          if (this.numberOfDays) {
            payload.days_count = this.numberOfDays
          } else {
            let { start_date, end_date } = this.config.params
            payload.start_date = start_date
            payload.end_date = end_date
          }

          return await $serviceContacts.fetchRecentTickets({params: payload}).then((response) => {
            const results = response.data.data
            let ticketData = []
            if (results.length > 0) {
              results.forEach((ticket) => {
                ticketData.push({
                  action_time: ticket.created_at,
                  event_name: 'Ticket',
                  ...ticket
                })
              })
            }
            // Show ticket count
            this.typeOfData.service.tickets = ticketData.length
            this.initializeFilters(this.typeOfData)
            return ticketData 
          }).catch(() => {
            return []
          })
        } else {
          return []
        }
      },
      endJourneyDialog(status,id){
        if(status == 'open'){
          this.endDialog=true;
          this.journey_id = id;
        }
        else if(status == 'close'){
          this.endDialog=false;
          this.journey_id = null;
        }
      },
      restartJournyDialog(status,id){
        if(status == 'open'){
          this.restartDialog=true;
          this.journey_id = id;
        }
        else if(status == 'close'){
          this.restartDialog=false;
          this.journey_id = null;
        }
      },
      endJourney(){
        $marketingContacts.endJourney(
          this.journey_id,
          this.contactId
        ).then(response => {
          this.$store.commit('ui/snackbar',{
            message : response.data.message,
            type: 'success'
          })
          this.endDialog=false;
          this.endDisabled = true;
          if(this.resetDisabled){
            this.resetDisabled = false;
          }
          this.getCustomerEngagementData();
        })
        .catch(error =>{
          this.endDialog=false;
          this.$store.commit('ui/snackbar',{
            message : 'Something went wrong. Please try again.',
            type: 'error'
          })
        });
      },
      restartJourney(){
        $marketingContacts.resetJourney(
          this.journey_id,
          this.contactId
        ).then(response => {
          this.$store.commit('ui/snackbar',{
            message : response.data.message,
            type: 'success'
          })
          this.restartDialog=false;
          this.endDisabled = false;
          this.getCustomerEngagementData();
        })
        .catch(error =>{
          this.restartDialog=false;
          this.$store.commit('ui/snackbar',{
            message : 'Something went wrong. Please try again.',
            type: 'error'
          })
        });
      },
      resetFilters(){
        let marketingFilters = [
          { id: 3, name: 'Bounced', parent:'email_campaign', value : 'bounced' },
          { id: 4, name: 'Clicked',parent:'email_campaign', value : 'clicked' },
          { id: 5, name: 'Delivered', parent:'email_campaign', value : 'delivered' },
          { id: 6, name: 'Opened', parent:'email_campaign', value : 'opened' },
          { id: 7, name: 'Unsubscribed',parent:'email_campaign', value : 'unsubscribed' },
          { id: 9, name: 'Active', parent : 'journey', value : 'Active' },
          { id: 10, name: 'Cleansed', parent : 'journey', value : 'Cleansed' },
          { id: 11, name: 'Finished', parent : 'journey', value : 'Finished'  },
          { id: 12, name: 'Paused' , parent : 'journey', value : 'Paused' },
          { id: 13, name: 'Unsubscribed', parent : 'journey', value : 'Unsubscribed'  },
          { id: 15, name: 'Orders', parent : 'commerce',value : 'orders' },
          { id: 16, name: 'Abandoned Carts', parent : 'commerce',value : 'abandoned_carts' },
        ]
        let serviceFilters = [
          { id: 17, name: 'Tickets',parent : 'service', value : 'tickets' },
        ]
        if (
          this.currentAccount.enable_marketing
          && this.currentAccount.enable_service
          && this.$can('read','contacts')
          && this.roles.includes('contacts')
        ) {
          this.selectedFilter = [ 
            ...marketingFilters,
            ...serviceFilters
          ]
        } else if (
          this.currentAccount.enable_marketing
          && this.roles.includes('contacts')
        ) {
          this.selectedFilter = [ 
            ...marketingFilters
          ]
        } else {
          this.selectedFilter = [
            ...serviceFilters
          ]
        }
      },
      orderCount(filterValues){
        let count = 0
        if(filterValues.orders && filterValues.orders.orders){
          count = filterValues.orders.orders
        }
        return count
      },
      initializeFilters(filterValues){
        let orderCount = this.orderCount(filterValues)
        let marketingFilters = []
        let serviceFilters = []
        let commerceFilter = [{
              id: 14,
              name: 'Commerce',
              count: orderCount + filterValues.abandoned_carts.abandoned_carts,
              children: [
                { id: 15, name: 'Orders',count: orderCount, parent : 'commerce', value : 'orders' }
              ],
            }]
        if (
          this.currentAccount.enable_marketing
          && this.roles.includes('contacts') 
        ) {
          commerceFilter[0].children.push({ id: 16, name: 'Abandoned Carts',count: filterValues.abandoned_carts.abandoned_carts, parent : 'commerce', value : 'abandoned_carts' })
          marketingFilters = [
            {
              id: 1,
              name: 'Marketing',
              count: (filterValues.email_campaign.bounced + filterValues.email_campaign.clicked +
                filterValues.email_campaign.delivered + filterValues.email_campaign.opened + filterValues.email_campaign.unsubscribed
                + filterValues.journey.Active + filterValues.journey.Cleansed +filterValues.journey.Unsubscribed +
                filterValues.journey.Paused + filterValues.journey.Finished),
              children: [
                { id: 2, name: 'Email Campaigns', count: (filterValues.email_campaign.bounced + filterValues.email_campaign.clicked +
                filterValues.email_campaign.delivered + filterValues.email_campaign.opened + filterValues.email_campaign.unsubscribed),
                children:[
                    { id: 3, name: 'Bounced', count: filterValues.email_campaign.bounced, parent:'email_campaign', value : 'bounced' },
                    { id: 4, name: 'Clicked',count: filterValues.email_campaign.clicked, parent:'email_campaign', value : 'clicked' },
                    { id: 5, name: 'Delivered',count: filterValues.email_campaign.delivered, parent:'email_campaign', value : 'delivered' },
                    { id: 6, name: 'Opened',count: filterValues.email_campaign.opened, parent:'email_campaign', value : 'opened' },
                    { id: 7, name: 'Unsubscribed',count: filterValues.email_campaign.unsubscribed,parent:'email_campaign', value : 'unsubscribed' },
                  ]},
                { id: 8, name: 'Journeys', count: ( filterValues.journey.Active + filterValues.journey.Cleansed +
                filterValues.journey.Paused + filterValues.journey.Finished + filterValues.journey.Unsubscribed),
                children:[
                    { id: 9, name: 'Active',count: filterValues.journey.Active, parent : 'journey', value : 'Active' },
                    { id: 10, name: 'Cleansed',count: filterValues.journey.Cleansed, parent : 'journey', value : 'Cleansed' },
                    { id: 11, name: 'Finished',count: filterValues.journey.Finished, parent : 'journey', value : 'Finished'  },
                    { id: 12, name: 'Paused' ,count: filterValues.journey.Paused, parent : 'journey', value : 'Paused' },
                    { id: 13, name: 'Unsubscribed',count: filterValues.journey.Unsubscribed, parent : 'journey', value : 'Unsubscribed'  }
                  ]
                  },
              ],
            },
          ]
         
        }
        if (
          this.currentAccount.enable_service
          && this.$can('read','contacts') 
        ) {
          serviceFilters = [
            {
              id: 17,
              name: 'Service',
              count: filterValues.service.tickets,
              children: [
                { id: 18, name: 'Tickets',count: filterValues.service.tickets, parent : 'service', value : 'tickets' }
              ],
            }
          ]
        }
        if (
          this.currentAccount.enable_marketing
          && this.currentAccount.enable_service
          && this.$can('read','contacts')
          && this.roles.includes('contacts')
        ) {
          this.filters = [ 
            ...marketingFilters,
            ...commerceFilter,
            ...serviceFilters
          ]
        } else if (
          this.currentAccount.enable_marketing
          && this.roles.includes('contacts')
        ) {
          this.filters = [ 
            ...marketingFilters,
            ...commerceFilter
          ]
        } else {
          this.filters = [
            ...serviceFilters,
            ...commerceFilter,
          ]
        }
      },
      async fetchFiltersData () {
        let config;
         if(this.numberOfDays){
          config = {
            params : {
              days_count:this.numberOfDays,
              'contact[email]': this.contactInfo.email
            }
          }
        } else {
          config = {
            params: {
              start_date: this.fromDate,
              end_date: this.toDate,
              'contact[email]': this.contactInfo.email
            }
          }
        }
        
        if (
          this.currentAccount.enable_marketing
          && this.currentAccount.enable_service
          && this.$can('read','contacts')
          && this.roles.includes('contacts')
        ) {
          await $marketingContacts.filters(this.contactInfo.id,config).then(response => {
            let result = response.data.data
            result.service = { tickets: this.typeOfData.service.tickets }
            this.typeOfData = result
            this.initializeFilters(result)
          })
        } else if (
          this.currentAccount.enable_marketing
          && this.roles.includes('contacts')
        ) {
          await $marketingContacts.filters(this.contactInfo.id,config).then(response => {
            let result = response.data.data
            this.typeOfData = result
            this.initializeFilters(result)
          })
        } else {
            await $marketingContacts.filters(this.contactInfo.id,config).then(response => {
            let result = response.data.data
            result.service = { tickets: this.typeOfData.service.tickets }
            this.typeOfData = result
            this.initializeFilters(result)
          })
        }
      },
       fetchTilesData (type) {
        $marketingContacts.stat(this.contactInfo.id, type,this.config).then(response => {
          if(type === 'recent_bounces_rate')
            this.engagement_tiles_data[type] = response.data.data.rate
          else
          this.engagement_tiles_data[type] = response.data.data.count
          if(type ===  'recent_opens_count')
             this.engagement_tiles_data.recent_opens_count_percent = response.data.data.rate
          if(type ===  'recent_clicks_count')
             this.engagement_tiles_data.recent_clicks_count_percent = response.data.data.rate

        }).catch(error => {
          console.error('Error', error)
        })
      },
      onTicketView (item) {
        if (process.env.VUE_APP_PRODUCT == 'Service') {
          this.$router.push({ name: 'ticket-details', params: { id: item.id } })
        } else {
          window.open(`/service/${this.account.id}/tickets/${item.id}`, '_blank');
        }
      },
      onOpenFilter () {
        this.filterDrawer = !this.filterDrawer
      },
      openLink (url) {
        if (process.env.VUE_APP_PRODUCT == 'Marketing') {
          this.$router.push(url)
        } else {
          window.open(url, '_blank');
        }
      },
    },
  }

</script>

<style lang="scss" scoped>
 .v-navigation-drawer--close{
   z-index: -1;
 }
.vr {
    width:1px;
    background-color:#03B6FC;
    position:absolute;
    top:0;
    bottom:0;
    left:34px;
}
.bg-hide{
    background: white;
    z-index: 2;
}
.fix-activities-height{
  height:819px;
  overflow-y:auto
  }
.web-history{
  width:85%;
}
.grey-border{
  border-bottom:1px solid lightgray
}
.grey-color{
  color:#999999;
}
.strike-not-through {
  position: relative;
}
.strike-not-through :first-line {
  background-color: #fafafa;
}
.custom-align-icon{
  align-items: start;
  margin-top: 3px;
}
.bounce-count{
  clear: both;
}
.customer-engagement-font{
  font-family: Roboto !important;
}
.customer-engagement {
  font-family: 'Montserrat';
}
.days {
  line-height: 24px;
}
</style>
